import { Injectable } from '@angular/core';

import { PrivaSegmentService } from '@priva/analytics/segment';
import { CurrentUser, PrivaAuthCurrentUserService } from '@priva/auth/current-user';

import { TrackEventType } from 'shared/analytics/track-events.model';

@Injectable()
export class TrackEventsService {
    user: CurrentUser;

    constructor(
        private readonly authService: PrivaAuthCurrentUserService,
        private readonly segmentService: PrivaSegmentService,
    ) {
        this.authService.user.subscribe((user) => (this.user = user));
    }

    track(trackEvent: TrackEventType): Promise<PrivaSegmentService> {
        if (trackEvent === undefined) {
            return;
        }

        trackEvent.context ??= {};

        trackEvent.context.userId = this.user.id;
        trackEvent.context.tenantId = this.user.tenantId;

        return this.segmentService.track(trackEvent.type, {
            ...trackEvent.context,
            ...trackEvent.properties,
        });
    }
}
